
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Route } from 'vue-router';
import api from '@/api';
import Swal from 'sweetalert2';
import ItemForm from './Form.vue';

const { pointCalculator } = api;

@Component({
  components: {
    ItemForm,
  },
})
export default class PointCalculatorEdit extends Vue {
  @Prop() private id!: string;

  private loading = false;

  private form = {
    name: '',
    expiredTime: '',
    rate: 0,
    initialNumberOfWishes: 0,
    commentUrl: '',
    itemId: null,
  };

  private setForm(form: any) {
    this.form = form;
  }

  private async submit(form: any) {
    if (form) {
      this.loading = true;
      const { status, message } = await pointCalculator.edit(this.id, form);
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: '修改成功' });
        this.$router.back();
      } else {
        await Swal.fire({ icon: 'warning', title: message });
      }
      this.loading = false;
    }
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: PointCalculatorEdit) => void) | boolean) => void,
  ) {
    const { data } = await pointCalculator.get(to.params.id);
    await next(async (vm) => {
      vm.setForm(data);
    });
  }
}
